import { qzTrayPayloadApi } from "../../api";

/**
 * 🖨️ QzTrayPayloadService
 *
 * Gestiona la obtención de payloads QZ Tray para impresión local.
 * Cada payload incluye comandos ESC/POS, vista previa PDF y metadatos firmados.
 *
 * ✅ Funcionalidad principal:
 * - Obtener el payload completo de impresión por tipo y ID.
 * - Compatible con los DTOs del backend:
 *   QzTrayPayloadDTO, QzEscPosCommandDTO, PrintablePreviewDTO, MetadataDTO.
 */
const QzTrayPayloadService = {
  /**
   * ⚙️ Obtener payload completo de impresión
   * GET /api/printing/qztray/payload?type=SALE&id=152
   */
  async getPayload(type: string, id: number) {
    const response = await qzTrayPayloadApi.fetchCustom(`/payload?type=${type}&id=${id}`);
    return response.data;
  },
};

export default QzTrayPayloadService;
